import React from "react";
import BaseComponent from "../baseComponent.js";
import PreLoader from "../common/preloader.jsx";
import IdentityAccessService from "../../core/services/identityAccessService.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import styles from "./login.scss";

export default class Login extends BaseComponent {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      username: "",
      password: "",
      error: null
    }
  }

  componentDidMount() {
    $("#loading").hide();
    $(this.refs.username).focus();
    //material library bug. need to investigate
    setTimeout(() => {
      $(this.refs.username).next().addClass("active");
      $(this.refs.password).next().addClass("active");
    }, 200);

    this.subscribe('solaceException', () => {
      this.setState({
        error: "Server did not respond try again."
      });
      this.hideLoader();
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  handleChange(event, field) {
    var state = {};
    state[field] = event.target.value;
    this.setState(state);
  }

  handleKeyUp(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  login() {
    this.state.username = this.state.username.trim(); //get rid of white spaces for login
    if (this.validate()) {
      this.showLoader();
      IdentityAccessService.login(this.state.username, this.state.password).then((response) => {
        this.hideLoader();
        if (response.status !== 0) {
          this.setState({
            error: "Invalid username or password."
          });
        } else {
          const lastLoggedInUserId = localStorage.getItem("userId");
          if (lastLoggedInUserId && lastLoggedInUserId !== this.state.username) {
            localStorage.removeItem("lastOpenedDashboard");
          }
          localStorage.setItem("userId", this.state.username);
          if (localStorage.getItem("lastOpenedDashboard")) {
            this.router.replace("/dashboard");
          } else {
            this.router.replace("/");
          }
          var user = IdentityAccessService.getUserProfile();
          this.publish(InternalEvent.App.USER_LOGEDIN, user);
        }
      });
    }
  }

  handleCreateAccount() {
    this.router.replace("/signup");
  }

  validate() {
    var isValid = true;
    if (this.state.username.length === 0 || this.state.password.length === 0) {
      this.setState({
        error: "Enter any username and password."
      });
      isValid = false;
    }

    return isValid;
  }

  showLoader() {
    $(this.refs.backdrop).show();
    this.refs.preloader.show();
    $(".login-modal__login-btn").animate({opacity: 0.7}, 250);
  }

  hideLoader() {
    $(this.refs.backdrop).hide();
    this.refs.preloader.hide();
    $(".login-modal__login-btn").animate({opacity: 1}, 250);
  }

  render() {
    var error;

    if (this.state.error) {
      error = <div className="col s12">
        <div className="login-modal__error">
          <i className="fa fa-exclamation-triangle"/>
          <span>{this.state.error}</span>
        </div>
      </div>
    }

    return (
      <div className={styles.backdrop}>
        <div className={styles.container}>
          <div className="row">
            <div className="col s12">
              <div className={styles.title}>Log In</div>
            </div>
            {error}
            <form className="col s12" id="loginForm" onSubmit={this.login} >
              <div className="row">
                <div className="input-field col s12">
                  <i className="material-icons prefix">perm_identity</i>
                  <input id="login_username" type="text" className="validate" ref="username"
                         value={this.state.username} onKeyUp={(e) => this.handleKeyUp(e)}
                         onChange={(e) => this.handleChange(e, "username")}/>
                  <label htmlFor="login_username">Username</label>

                </div>
                <div className="input-field col s12">
                  <i className="material-icons prefix">lock_outline</i>
                  <input id="login_password" type="password" className="validate" ref="password"
                         value={this.state.password} onKeyUp={(e) => this.handleKeyUp(e)}
                         onChange={(e) => this.handleChange(e, "password")}/>
                  <label htmlFor="login_password">Password</label>
                </div>
              </div>
            </form>
            <div className="col s12">
              <button type="button" form="loginForm" className={["waves-effect waves-light btn", styles.button].join(" ")} onClick={this.login}>LOG
                IN</button>
            </div>
            <div className="col s12">
              <div className={styles.forgotMessage}>Forgot your <span
                className={styles.accent} onClick={() => this.router.replace("/forgot-password")}>password?</span></div>
            </div>
            <div className={styles.createAccount}>
              <a className={styles.createAccountLink} href="mailto:signup@smash.bi">CREATE NEW ACCOUNT</a>
            </div>
            <div className={styles.preloader} ref="backdrop">
              <PreLoader ref="preloader"/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Login.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/auth/login.jsx